// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"55a90ed9","479":"4248ef24"}[chunkId] + ".chunk.js";
};